module.exports = __webpack_public_path__ + "media/images/application/icons/socials/icon-link-2a2be94ad0a2d931f49c1599858e9a7d.svg";